const auto = {
  Weixin: {
    iOS: {
      action: 'ul',
      fallback: ''
    },
    Android: {
      action: 'yingyongbao',
      fallback: ''
    }
  },
  Safari: {
    iOS: {
      action: 'ul',
      fallback: ''
    },
    Android: {
    }
  },
  Chrome: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: 'schema',
      fallback: ''
    }
  },
  UC: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: 'schema',
      fallback: 'download'
    }
  },
  TaoBao: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: 'schema',
      fallback: 'download'
    }
  },
  TaoBaoLite: {
    iOS: {
      action: 'ul',
      fallback: ''
    },
    Android: {
      action: 'schema',
      fallback: 'download'
    }
  },
  DingTalk: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: 'schema',
      fallback: ''
    }
  },
  QQBrowser: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: 'yingyongbao',
      fallback: ''
    }
  },
  QQ: {
    iOS: {
      action: 'schema',
      fallback: 'browser'
    },
    Android: {
      action: 'yingyongbao',
      fallback: ''
    }
  },
  Alipay: {
    iOS: {
      action: 'schema',
      fallback: 'appstore'
    },
    Android: {
      action: 'schema',
      fallback: 'download'
    }
  },
  Weibo: {
    iOS: {
      action: 'schema',
      fallback: 'browser'
    },
    Android: {
      action: 'schema',
      fallback: 'browser'
    }
  },
  default: {
    iOS: {
      action: 'schema',
      fallback: 'ul'
    },
    Android: {
      action: 'schema',
      fallback: ''
    }
  }
};

const pageClick = {
  Weixin: {
    iOS: {
      action: 'ul',
      fallback: ''
    },
    Android: {
      action: 'yingyongbao',
      fallback: ''
    }
  },
  Safari: {
    iOS: {
      action: 'ul',
      fallback: ''
    },
    Android: {
    }
  },
  Chrome: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: '',
      fallback: ''
    }
  },
  UC: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: 'schema',
      fallback: 'download'
    }
  },
  TaoBao: {
    iOS: {
      action: 'schema',
      fallback: ''
    },
    Android: {
      action: 'schema',
      fallback: 'download'
    }
  },
  DingTalk: {
    iOS: {
      action: 'schema',
      fallback: 'browser'
    },
    Android: {
      action: 'schema',
      fallback: 'browser'
    }
  },
  QQBrowser: {
    iOS: {
      action: 'schema',
      fallback: 'appstore'
    },
    Android: {
      action: 'schema',
      fallback: ''
    }
  },
  QQ: {
    iOS: {
      action: 'schema',
      fallback: 'browser'
    },
    Android: {
      action: 'schema',
      fallback: 'browser'
    }
  },
  Alipay: {
    iOS: {
      action: 'schema',
      fallback: 'appstore'
    },
    Android: {
      action: 'schema',
      fallback: 'download'
    }
  },
  Weibo: {
    iOS: {
      action: 'schema',
      fallback: 'browser'
    },
    Android: {
      action: 'schema',
      fallback: 'browser'
    }
  },
  default: {
    iOS: {
      action: 'schema',
      fallback: 'ul'
    },
    Android: {
      action: 'schema',
      fallback: ''
    }
  }
};

const call = {
  auto,
  pageClick,
  btnClick: pageClick,
};

export default {
  ...call,
};
